import { render, staticRenderFns } from "./BulkFieldMapping.vue?vue&type=template&id=0f309e6c&scoped=true"
import script from "./BulkFieldMapping.vue?vue&type=script&lang=ts"
export * from "./BulkFieldMapping.vue?vue&type=script&lang=ts"
import style0 from "./BulkFieldMapping.vue?vue&type=style&index=0&id=0f309e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f309e6c",
  null
  
)

export default component.exports